// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-148b3946]{color:#0c83d3}.form-group[data-v-148b3946]{margin-left:0;margin-right:0}@media only screen and (max-width: 768px){textarea[data-v-148b3946]{font-size:.8rem}}", ""]);
// Exports
module.exports = exports;
